/** Results section — slow auto-rotating testimonials */
(function () {
  document.querySelectorAll('[data-zm-testimonials]').forEach((root) => {
    const items = [...root.querySelectorAll('[data-zm-testimonial]')];
    const dots = [...root.querySelectorAll('[data-zm-testimonial-dot]')];
    const track = root.querySelector('.zm-testimonials__track');
    if (items.length < 2) return;

    const READ_MS = 11000;

    let index = 0;
    let timer;

    function syncTrackHeight() {
      if (!track) return;
      const active = items[index];
      if (!active) return;
      track.style.minHeight = `${active.offsetHeight}px`;
    }

    function show(i) {
      index = (i + items.length) % items.length;
      items.forEach((el, n) => el.classList.toggle('is-active', n === index));
      dots.forEach((dot, n) => {
        dot.classList.toggle('is-active', n === index);
        dot.setAttribute('aria-selected', n === index ? 'true' : 'false');
      });
      requestAnimationFrame(syncTrackHeight);
    }

    function next() {
      show(index + 1);
    }

    function start() {
      clearInterval(timer);
      timer = setInterval(next, READ_MS);
    }

    dots.forEach((dot, i) => {
      dot.addEventListener('click', () => {
        show(i);
        start();
      });
    });

    root.addEventListener('mouseenter', () => clearInterval(timer));
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', () => clearInterval(timer));
    root.addEventListener('focusout', (e) => {
      if (!root.contains(e.relatedTarget)) start();
    });

    window.addEventListener('resize', syncTrackHeight);

    show(0);
    start();
  });
})();
